/* Ana Quispe — mejoras de la zona de compra: muestras de color, talla obligatoria y barra fija en móvil. */
(function () {
  var SWATCHES = {
    blanco: '#ffffff', negro: '#1b1b1b', gris: '#9a9a9a', 'gris oscuro': '#555555', beige: '#e8dcc8',
    camel: '#c19a6b', 'azul marino': '#1f2a44', azul: '#2f5aa8', celeste: '#9cc7e8', rojo: '#b3261e',
    vino: '#6d2232', burdeos: '#6d2232', verde: '#3f6b3a', 'verde oliva': '#5f6236', rosa: '#e8b4bc',
    'marrón': '#6b4a2f', marron: '#6b4a2f', crema: '#f3ead7', amarillo: '#e8c547', naranja: '#d9772b',
    morado: '#5b3a7a', lila: '#b9a3d0', mostaza: '#c99a2e', chocolate: '#4a2f1f', hueso: '#efe8da',
    arena: '#d8c7a8', caqui: '#a89a6a'
  };
  var SIZE_PROMPT = 'Elige una talla';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function optionName(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return '';
    var first = legend.childNodes[0];
    return ((first && first.nodeType === 3 ? first.textContent : legend.textContent) || '').trim().toLowerCase();
  }
  function isSize(name) { return /^(talla|size|tama)/.test(name); }
  function isColor(name) { return /^(color|colour)/.test(name); }
  function scopeOf(el) { return el.closest('product-info') || el.closest('.product__info-wrapper') || document.documentElement; }
  function sizeChosen(scope) { return scope.dataset.aqSize === '1'; }
  function sizeFieldset(scope) {
    var sets = scope.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) if (isSize(optionName(sets[i]))) return sets[i];
    return null;
  }

  function decorate() {
    document.querySelectorAll('variant-selects fieldset').forEach(function (fieldset) {
      var name = optionName(fieldset);
      if (isColor(name)) {
        fieldset.classList.add('aq-color');
        fieldset.querySelectorAll('input[type=radio]').forEach(function (input) {
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          var hex = SWATCHES[(input.value || '').trim().toLowerCase()];
          if (label && hex && label.style.getPropertyValue('--aq-sw') !== hex) label.style.setProperty('--aq-sw', hex);
        });
      }
      if (isSize(name)) {
        var scope = scopeOf(fieldset);
        var chosen = sizeChosen(scope);
        if (fieldset.classList.contains('aq-need-size') === chosen) fieldset.classList.toggle('aq-need-size', !chosen);
        var msg = fieldset.querySelector('.aq-size-msg');
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'aq-size-msg';
          msg.setAttribute('role', 'alert');
          msg.textContent = 'Elige tu talla para continuar';
          fieldset.appendChild(msg);
        }
        if (chosen && msg.classList.contains('is-visible')) msg.classList.remove('is-visible');
        var value = fieldset.querySelector('legend [data-selected-value]');
        if (value && !chosen && value.textContent !== SIZE_PROMPT) value.textContent = SIZE_PROMPT;
      }
    });
  }

  if (/[?&]variant=/.test(location.search)) {
    document.querySelectorAll('product-info').forEach(function (p) { p.dataset.aqSize = '1'; });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    var fieldset = input.closest('fieldset');
    if (fieldset && isSize(optionName(fieldset))) scopeOf(fieldset).dataset.aqSize = '1';
    setTimeout(decorate, 0);
  }, true);

  function blockIfNoSize(event, origin) {
    var scope = scopeOf(origin);
    var fieldset = sizeFieldset(scope);
    if (!fieldset || sizeChosen(scope)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    decorate();
    var msg = fieldset.querySelector('.aq-size-msg');
    if (msg) msg.classList.add('is-visible');
    fieldset.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var first = fieldset.querySelector('input[type=radio]:not(:disabled)');
    if (first) first.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.product-form__submit');
    if (button) blockIfNoSize(event, button);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.closest && event.target.closest('product-form')) blockIfNoSize(event, event.target);
  }, true);

  function setupSticky() {
    var info = document.querySelector('#MainContent product-info');
    if (!info) return;
    var mainButton = info.querySelector('.product-form__submit');
    if (!mainButton) return;
    var titleEl = info.querySelector('.product__title h1, .product__title .h1');
    var bar = document.createElement('div');
    bar.className = 'aq-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="aq-sticky__info"><div class="aq-sticky__title"></div><div class="aq-sticky__variant"></div></div><button type="button" class="button button--primary" tabindex="-1">Añadir al carrito</button>';
    document.body.appendChild(bar);
    var barButton = bar.querySelector('button');
    var titleBox = bar.querySelector('.aq-sticky__title');
    var variantBox = bar.querySelector('.aq-sticky__variant');

    function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    function refresh() {
      var button = info.querySelector('.product-form__submit');
      if (!button) return;
      mainButton = button;
      setText(titleBox, titleEl ? titleEl.textContent.trim() : '');
      var price = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
      var parts = [];
      if (sizeFieldset(info) && !sizeChosen(info)) parts.push('Elige tu talla');
      else info.querySelectorAll('variant-selects input[type=radio]:checked').forEach(function (i) { parts.push(i.value); });
      if (price) parts.push(price.textContent.trim());
      setText(variantBox, parts.join(' · '));
      var unavailable = button.disabled || button.getAttribute('aria-disabled') === 'true';
      barButton.disabled = unavailable;
      setText(barButton, unavailable ? (button.textContent || '').trim() : 'Añadir al carrito');
    }
    barButton.addEventListener('click', function () { mainButton.click(); });

    var visible = false;
    function show(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      barButton.tabIndex = on ? 0 : -1;
      document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0 && window.innerWidth < 990);
    }).observe(mainButton);
    new MutationObserver(refresh).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    document.addEventListener('change', function () { setTimeout(refresh, 50); });
    refresh();
  }

  function init() {
    decorate();
    setupSticky();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) if (nodes[j].nodeType === 1) { decorate(); return; }
      }
    }).observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();